import callApi from '../../util/apiCaller';
import moment from 'moment';
import clone from 'lodash/clone';
import LEADFORM_GOAL_TRACKING_STAGE from '../../util/leadFormTracking';
import {
    loadPreSelectedLeadformAndOpenLeadForm,
    setEventRedirectionUrl,
    toggleHomeLeadFormState,
    toggleLeadFormState,
    toggleVenueLeadFormState,
} from './LeadActions';
import { EVEN_TRIGGER_CODE, ODD_TRIGGER_CODE } from '../../constants/leadFormConstants';
import { loadEvent, savedEventInfo, toggleLoaderForEventPlan } from './EventActions';
import { getHomeLeadFormVisibleState, getLeadFormVisibleState } from '../selectors/LeadSelectors';
import { getIsLeadFormVisible } from '../selectors/LeadFormSelectors';
import { loginOtpFailure, loginOtpSuccess } from './AppActions';
import { saveEventIdToStorage } from '../../util/vmStorageHandler';
import {
    processGtmDatalayer,
    processPageViewUrlForNewOldLeadForm,
} from '../../util/leadFormHandler';

import {
    checkIfToShowWhichLeadFormBasedOnCity,
    getLeadFormType,
    getNCRLeadFormTriggerCodeBasedOnOccasion,
    setLeadFormNcrPopUp,
} from '../../util/leadFormUtility';
import { userNotify } from '../../modules/components/Toasts/ToastAdd';
import eventCallApi from '../../util/apiEventCaller';
import { gtmAlert, gtmUserIdTrigger } from '../../util/gtmTrigger';
import { verifyOTPCode } from './EventVerificationActions';
import { newGtmCustomEvent } from '../../modules/utility/gtmTrigger';
import { getSelectedVenues } from '../selectors/VenueSelectors';
import { VENUE_MODEL } from '../../constants/constants';
import { getCurrentPage } from '../../util/vmCookieHandler';
import { createSuperEvent } from '../../modules/utility/trackingWrapper';
import {getLeadFormVariables, checkIfShowBasedOnCookieInfo} from '../../util/leadFormUtility';
import { toggleSideMenuBarModal } from './HeaderActions';

export const SET_CONFIG = 'SET_CONFIG';
export const SET_IS_SUBMITTING = 'SET_IS_SUBMITTING';
export const SET_EVENT = 'SET_EVENT';
export const SET_TIME_LEFT = 'SET_TIME_LEFT';
export const SET_IS_RESEND_VISIBLE = 'SET_IS_RESEND_VISIBLE';
export const SET_IS_OTP_INVALID = 'SET_IS_OTP_INVALID';
export const SET_IS_LEAD_FORM_VISIBLE = 'SET_IS_LEAD_FORM_VISIBLE';
export const SET_IS_HOME_LEAD_FORM_VISIBLE = 'SET_IS_HOME_LEAD_FORM_VISIBLE';
export const SET_BASIC_DETAIL = 'SET_BASIC_DETAIL';
export const SET_FREE_FOOD_LEAD_FORM_VISIBLE_STATE = 'SET_FREE_FOOD_LEAD_FORM_VISIBLE_STATE';
export const SET_CONNECT_VM_LEAD_FORM_VISIBLE_STATE = 'SET_CONNECT_VM_LEAD_FORM_VISIBLE_STATE';
export const SHOW_OTP_SEGMENT_FFTVM = 'SHOW_OTP_SEGMENT_FFTVM';
export const WRONG_OTP_STATE = 'WRONG_OTP_STATE';
export const SET_HAVE_US_CALL_YOU_FORM_VISIBLE_STATE = 'SET_HAVE_US_CALL_YOU_FORM_VISIBLE_STATE';
export const SET_ENQIRY_FORM_PARAMS = 'SET_ENQIRY_FORM_PARAMS';
export const SET_ENQUIRY_VISIBLE_STATE = 'SET_ENQUIRY_VISIBLE_STATE';
export const SET_ENQUIRY_FORM_PAGE_TYPE = 'SET_ENQUIRY_FORM_PAGE_TYPE';
export const SIDEBAR_HAVE_US_CALL_YOU_FILLED = 'SIDEBAR_HAVE_US_CALL_YOU_FILLED';
export const SET_SELECTED_CATATAGORY_TYPE = 'SET_SELECTED_CATATAGORY_TYPE';

export const setBasicDetail = (basicDetails) => {
    return {
        type: SET_BASIC_DETAIL,
        basicDetails,
    };
};

export const setIsLeadFormVisible = (
    isLeadFormVisible,
    selectedLeadForm = {},
    leadFormTriggerCode
) => {
    return {
        type: SET_IS_LEAD_FORM_VISIBLE,
        isLeadFormVisible,
        selectedLeadForm,
        leadFormTriggerCode,
    };
};

export const setIsHomeLeadFormVisible = (
    isHomeLeadFormVisible,
    selectedLeadForm = {},
    leadFormTriggerCode
) => {
    return {
        type: SET_IS_HOME_LEAD_FORM_VISIBLE,
        isHomeLeadFormVisible,
        selectedLeadForm,
        leadFormTriggerCode,
    };
};

const getLeadFormEntities = (input, selectedLeadForm) => {
  let selectedLeadFormVariable = clone(selectedLeadForm);
  selectedLeadFormVariable.city = input?.venue?.city ? input.venue.city : [];
  selectedLeadFormVariable.venuetype =
      input.venue && input.venue.propertyType && input.venue.propertyType.length > 0
          ? input.venue.propertyType[0]
          : '';
  selectedLeadFormVariable.location =
      input.venue && input.venue.sub_area ? input.venue.sub_area : '';
  return selectedLeadFormVariable;
};

export const checkPopupClosing = (isAuthenticated, venue, selectedLeadForm) => {
    // qlwdlkqwj
    return (dispatch) => {
        let check = checkIfShowBasedOnCookieInfo(isAuthenticated);
        if (check?.formCount <= 1) {
            setTimeout(() => {
                const variables = getLeadFormVariables(isAuthenticated);
                if (variables.showPopup) {
                  const selectedLeadFormEntities = getLeadFormEntities(venue, selectedLeadForm);
                  dispatch(
                        showPreSelectedLeadForm(
                            variables.triggerCode,
                            selectedLeadFormEntities,
                            true,
                            '',
                            'auto'
                        )
                    );
                }
            }, 10000);
        }
    };
};

export const setIsSubmitting = (isSubmitting) => {
    return {
        type: SET_IS_SUBMITTING,
        isSubmitting,
    };
};

export const setConfig = (config) => {
    return {
        type: SET_CONFIG,
        config,
    };
};

const selectCatagory = () => {};
export const setSelectedCatagoryType = (catagory) => {
    return {
        type: SET_SELECTED_CATATAGORY_TYPE,
        selectedCatagory: catagory,
    };
};

export const setEvent = (event) => {
    return {
        type: SET_EVENT,
        event,
    };
};

export const setTimeLeft = (timeLeft) => {
    return {
        type: SET_TIME_LEFT,
        timeLeft,
    };
};

export const setIsResendVisible = (isResendVisible) => {
    return {
        type: SET_IS_RESEND_VISIBLE,
        isResendVisible,
    };
};

export const setIsOtpInvalid = (isOtpInvalid) => {
    return {
        type: SET_IS_OTP_INVALID,
        isOtpInvalid,
    };
};

export const fetchBasicDetails = (data) => (dispatch) => {
    callApi('new-lead-form/basic-detail', 'post', data)
        .then((res) => {
            if (res && res.status === 'Success') {
                dispatch(setBasicDetail(res.data.newleadform));
            }
        })
        .catch((err) => {
            userNotify(err.message, 'error');
        });
};

export function authenticateOTP(creds, next) {
    return (dispatch) => {
        return eventCallApi('v1/auth/authenticate-otp', 'post', creds, false , true).then((res) => {
            const { user, message, ok } = res.data;
            if (!ok) {
                dispatch(loginOtpFailure(message));
                if (!creds.donotShowPopupError) {
                    userNotify(message, 'danger');
                }
                dispatch(setIsOtpInvalid('Invalid OTP.'));
                return next('Invalid OTP.');
            } else {
                localStorage.setItem('token', res.data.token);
                localStorage.setItem('idToken', res.data.idToken);
                dispatch(loginOtpSuccess(user));
                gtmUserIdTrigger(user._id);
                processGtmDatalayer(
                    {
                        gtmPageView1: processPageViewUrlForNewOldLeadForm(
                            EVEN_TRIGGER_CODE,
                            `${LEADFORM_GOAL_TRACKING_STAGE['form-filled']}`,
                            'user'
                        ),
                    },
                    null
                );
                return next();
            }
        });
    };
}

export const sendOTP = (eventid, data) => (dispatch) => {
    dispatch(setIsSubmitting(true));
    dispatch(setTimeLeft(null));
    eventCallApi(`v3/dashboard/user/customer-event/${eventid}/send-otp-verify`, 'post', data)
        .then((res) => {
            dispatch(setIsSubmitting(false));
            if (res && res.status === 'Success') {
                dispatch(setTimeLeft(60));
                dispatch(setIsResendVisible(false));
            }
        })
        .catch((err) => {
            userNotify(err.message, 'error');
            dispatch(setIsSubmitting(false));
        });
};

export const verifyOTP = (eventid, data, next) => (dispatch) => {
    //hey
    dispatch(setIsSubmitting(true));
    eventCallApi(`v3/dashboard/user/event/${eventid}/verify-otp`, 'post', { code: data.code })
        .then((res) => {
            dispatch(setIsSubmitting(false));
            if (res && res.status === 'Success') {
                // send data to google analytics
                processGtmDatalayer(
                    {
                        gtmPageView1: processPageViewUrlForNewOldLeadForm(
                            EVEN_TRIGGER_CODE,
                            `${
                                LEADFORM_GOAL_TRACKING_STAGE['otp-verified']
                            }/${data.leadFormTriggerCode || 'user'}`,
                            data.leadFormTriggerCode || 'user'
                        ),
                    },
                    null
                );
                dispatch(savedEventInfo(res.data.event));
                dispatch(
                    authenticateOTP(
                        {
                            otp: data.code,
                            phone: data.phone,
                            donotShowPopupError: data.donotShowPopupError,
                            leadFormTriggerCode: data.leadFormTriggerCode || 'user',
                        },
                        (err, result) => {
                            if (err) {
                                return next('cannot verify otp');
                            } else {
                                return next(null, result);
                            }
                        }
                    )
                );
            }
        })
        .catch((err) => {
            if (!data.donotShowPopupError) {
                userNotify(err.message, 'error');
            }
            dispatch(setIsOtpInvalid(err.message));
            dispatch(setIsSubmitting(false));
            return next(err);
        });
};

export const planEvent = (data) => (dispatch) => {
    dispatch(setIsSubmitting(true));
    dispatch(toggleLoaderForEventPlan(true));
    dispatch(loadEvent({}, true));
    eventCallApi('v2/events/plan', 'post', data)
        .then((res) => {
            if (res && res.status === 'Success' && res.data && res.data.eventid) {
                const { event } = res.data;
                // setEventCookie(new Date(moment(res.data.event.event_date)
                //   .add(1, 'days')
                //   .toISOString()), res.data.eventid);
                saveEventIdToStorage(
                    new Date(
                        moment(res.data.event.event_date)
                            .add(1, 'days')
                            .toISOString()
                    ),
                    res.data.eventid
                );
                dispatch(loadEvent(res.data.event, false));

                if (res && res.data && res.data.event && res.data.event.guests) {
                    if (parseInt(res.data.event.guests) > 200) {
                        gtmAlert('lead_guest_count_gt_200');
                    }
                    if (parseInt(res.data.event.guests) > 50) {
                        gtmAlert('lead_guest_count_gt_50');
                    }
                }
                dispatch(setEventRedirectionUrl(res.data.url));
                eventCallApi(
                    `v3/dashboard/user/customer-event/${res.data.eventid}/send-otp-verify`,
                    'post',
                    {
                        phone: event.contact_phone,
                    }
                )
                    .then((res1) => {
                        if (res1 && res1.status === 'Success') {
                            if (res1 && res1.data && res1.data.event && res1.data.event !== '') {
                                // userNotify('OTP Sent', 'success');
                                userNotify('Event Created', 'success');
                                dispatch(setTimeLeft(60));
                                dispatch(setIsResendVisible(false));
                                dispatch(setIsSubmitting(false));
                                dispatch(setEvent(res.data));
                                dispatch(
                                    setConfig({
                                        view: 'user', // [user => 1, detail => 2, date => 3]
                                        otpView: true,
                                        skipVisible: false,
                                        isEdit: false,
                                    })
                                );
                            } else {
                                userNotify('Server did not respond, please try again', 'error');
                            }
                            // dispatch(verifyOTP(res.data.eventid, { code: res1.data.event.otp, phone: event.contact_phone }));
                            // dispatch(setConfig({
                            //   view: 'detail', // [user => 1, detail => 2, date => 3]
                            //   otpView: false,
                            //   skipVisible: true,
                            //   isEdit: false,
                            // }));
                        } else if (res1.status === 'Error' && res1.data.message) {
                            userNotify(res1.data.message, 'error');
                        } else {
                            userNotify('Server did not respond, please try again', 'error');
                        }
                    })
                    .catch((err) => {
                        dispatch(setIsSubmitting(false));
                        userNotify(err.message, 'error');
                    });
            }
        })
        .catch((err) => {
            dispatch(setIsSubmitting(false));
            userNotify(err.message, 'error');
        });
};

export const updatePhone = (userEventId, data) => (dispatch) => {
    dispatch(setIsSubmitting(true));
    eventCallApi(`customer/dashboard/user/${userEventId}/update-customer-phone`, 'post', {
        event: { ...data },
    })
        .then((res) => {
            if (res && res.status === 'Success') {
                const { event } = res.data;
                eventCallApi(
                    `v3/dashboard/user/customer-event/${event._id}/send-otp-verify`,
                    'post',
                    {
                        phone: event.contact_phone,
                    }
                )
                    .then((res1) => {
                        if (res1 && res1.status === 'Success') {
                            // userNotify('OTP Sent', 'success');
                            dispatch(setTimeLeft(60));
                            dispatch(setIsResendVisible(false));
                            dispatch(setIsSubmitting(false));
                            // dispatch(setEvent(res.data));
                            dispatch(
                                setConfig({
                                    view: 'user', // [user => 1, detail => 2, date => 3]
                                    otpView: true,
                                    skipVisible: false,
                                    isEdit: false,
                                })
                            );
                        }
                    })
                    .catch((err) => {
                        dispatch(setIsSubmitting(false));
                        userNotify(err.message, 'error');
                    });
            }
        })
        .catch((err) => {
            dispatch(setIsSubmitting(false));
            userNotify(err.message, 'error');
        });
};

export const updateEvent = (userId, data, view, callback) => (dispatch) => {
    dispatch(setIsSubmitting(true));
    dispatch(loadEvent({}, true));
    eventCallApi(`customer/dashboard/user/${userId}/update-customer-event`, 'post', {
        event: { ...data },
    })
        .then((res) => {
            dispatch(setIsSubmitting(false));
            if (res && res.status === 'Success') {
                dispatch(setEvent(res.data));
                if (res.data.event.event_date) {
                    // setEventCookie(new Date(moment(res.data.event.event_date)
                    // .add(1, 'days').toISOString()), res.data.event._id);
                    saveEventIdToStorage(
                        new Date(
                            moment(res.data.event.event_date)
                                .add(1, 'days')
                                .toISOString()
                        ),
                        res.data.event._id
                    );
                }
                dispatch(loadEvent(res.data.event, false));
                dispatch(
                    setConfig({
                        view, // [user => 1, detail => 2, date => 3]
                        otpView: false,
                        skipVisible: false,
                        isEdit: false,
                    })
                );
                callback(data.date || false);
            }
        })
        .catch((err) => {
            dispatch(setIsSubmitting(false));
            userNotify(err.message, 'error');
        });
};

export const showPreSelectedLeadForm = (
    triggerCode,
    selectedLeadForm,
    leadFormState,
    leadFormCode,
    leadFormTriggerCode
) => (dispatch, getState) => {
    const state = getState();
    let isLeadFormVisible = getLeadFormVisibleState(state);
    let isHomeLeadFormVisible = getHomeLeadFormVisibleState(state);
    let selectedVenue = getSelectedVenues(state);
    let currentPage = getCurrentPage();
    if (!isLeadFormVisible || !isHomeLeadFormVisible) {
        const leadFormType = getLeadFormType();

        createSuperEvent({
            event_name: `lead-form-popup`,
            feature_name: `open lead form`,
            action_name: `lead form opened`,
        });
        createSuperEvent({
            event_name: `lead-form-popup-${leadFormTriggerCode}`,
            feature_name: `open lead form`,
            action_name: `lead form opened`,
        });

        // const isNcrLeadForm =
            // checkIfToShowWhichLeadFormBasedOnCity() || leadFormType !== VENUE_MODEL;
        // if (isNcrLeadForm) {
            setLeadFormNcrPopUp(
                leadFormType,
                leadFormTriggerCode,
                selectedVenue,
                currentPage,
                'ncr'
            );
        // } else {
            // createSuperEvent({
            //     event_name: `non-ncr-lead-form-popup-${leadFormTriggerCode}`,
            //     feature_name: `open lead form`,
            //     action_name: `lead form opened`,
            // });
            // createSuperEvent({
            //     event_name: `non-ncr-lead-form-popup`,
            //     feature_name: `open lead form`,
            //     action_name: `lead form opened`,
            // });
        // }
        // if (isNcrLeadForm) {
            dispatch(
                loadPreSelectedLeadformAndOpenLeadForm(
                    selectedLeadForm,
                    leadFormState,
                    leadFormCode,
                    leadFormTriggerCode,
                    leadFormType
                )
            );
        // } else {
            // dispatch(setIsLeadFormVisible(true, selectedLeadForm, leadFormTriggerCode));
        // }
    }
};

export const toggleSideMenuBarModalAction = (val) => (dispatch) => {
    dispatch(toggleSideMenuBarModal(val));
};

export const toggleVenueLeadFormStateAction = (triggerCode, leadFormState, selectedVenue) => (
    dispatch
) => {
    if (triggerCode === EVEN_TRIGGER_CODE) {
        dispatch(setIsLeadFormVisible(true));
        dispatch(setIsHomeLeadFormVisible(true))
    } else if (triggerCode === ODD_TRIGGER_CODE) {
        dispatch(toggleVenueLeadFormState(leadFormState, selectedVenue));
    } else {
        dispatch(toggleVenueLeadFormState(leadFormState, selectedVenue)); // old
    }
};

export function setFreeFoodLeadFormVisibleState(visibility) {
    return {
        type: SET_FREE_FOOD_LEAD_FORM_VISIBLE_STATE,
        freeFoodLeadFormVisibleState: visibility,
    };
}

export function setConnectVMLeadFormVisibleState(visibility) {
    return {
        type: SET_CONNECT_VM_LEAD_FORM_VISIBLE_STATE,
        connectVmLeadFormVisibleState: visibility,
    };
}

export const setHaveUsCallYouFormVisibleState = (val) => {
    return {
        type: SET_HAVE_US_CALL_YOU_FORM_VISIBLE_STATE,
        haveUsCallYourFormVisibleState: val,
    };
};

export const setEnquiryFormVisibleState = (val) => {
    return {
        type: SET_ENQUIRY_VISIBLE_STATE,
        enquiryFormVisibleState: val,
    };
};
export const setEnquiryFormPageType = (type) => {
    return {
        type: SET_ENQUIRY_FORM_PAGE_TYPE,
        enquiryFormVisibleState: val,
    };
};

const setEnquiryPageParams = (params) => {
    return {
        type: SET_ENQIRY_FORM_PARAMS,
        enquiryFormParams: { ...params },
    };
};

export const setEnquiryFormVisible = ({
    pageType,
    vendorType,
    formType,
    btnSource,
    btnText,
    leadType,
}) => (dispatch) => {
    dispatch(showOtpSegmentForFFTVM(false));
    dispatch(setEnquiryFormVisibleState(true));
    dispatch(
        setEnquiryPageParams({
            enquiryFormleadType: leadType,
            enquiryFormPageType: pageType,
            enquiryFormVendorType: vendorType ? vendorType : '',
            enquiryFormType: formType,
            enquiryFormBtnSource: btnSource,
        })
    );
};

// FFT -> Free Food Tasting
// VM -> Connect Venue Manager
export const visibleLeadFormFFTVM = (context, visibility) => (dispatch) => {
    if (context === 'free-food') {
        dispatch(setFreeFoodLeadFormVisibleState(visibility));
    } else if (context === 'connect-vm') {
        dispatch(setConnectVMLeadFormVisibleState(visibility));
    }
};

export const showOtpSegmentForFFTVM = (visible) => {
    return {
        type: SHOW_OTP_SEGMENT_FFTVM,
        showOtpSegmentForFFTVM: visible,
    };
};
export const setSideBarHaveUsCallYouFilled = (visible) => {
    return {
        type: SIDEBAR_HAVE_US_CALL_YOU_FILLED,
        sideBarHaveUsCallYouFilled: visible,
    };
};


export const planEventForFFTVM = (data) => (dispatch) => {
    dispatch(setIsSubmitting(true));
    dispatch(showOtpSegmentForFFTVM(false));
    dispatch(loadEvent({}, true));
    return eventCallApi('v2/events/plan', 'post', data)
        .then((res) => {
            if (res && res.status === 'Success' && res.data && res.data.eventid) {
                const { event } = res.data;
                // dispatch(showOtpSegmentForFFTVM(true));
                saveEventIdToStorage(
                    res.data?.event?.event_date
                        ? new Date(
                              moment(res.data.event.event_date)
                                  .add(1, 'days')
                                  .toISOString()
                          )
                        : new Date(
                              moment()
                                  .add(7, 'days')
                                  .toISOString()
                          ),
                    res.data.eventid
                );
                dispatch(loadEvent(res.data.event, false));
                dispatch(setEventRedirectionUrl(res.data.url));
                // dispatch(setIsSubmitting(false));

                eventCallApi(
                    `v3/dashboard/user/customer-event/${res.data.eventid}/send-otp-verify`,
                    'post',
                    { phone: event.contact_phone }
                )
                    .then((res1) => {
                        if (res1 && res1.status === 'Success') {
                            dispatch(setIsSubmitting(false));
                            dispatch(setEvent(res.data));
                            dispatch(toggleLeadFormState(false, '', ''));
                            dispatch(toggleHomeLeadFormState(false, '', ''));
                            dispatch(showOtpSegmentForFFTVM(true));
                        } else if (res1 && res1.status === 'Error' && res1.data && res1.data.message) {
                            dispatch(setIsSubmitting(false));
                            dispatch(userNotify(res1.data.message, 'error'));
                        } else {
                            dispatch(setIsSubmitting(false));
                            dispatch(
                                userNotify('Server did not respond, please try again', 'error')
                            );
                        }
                    })
                    .catch((err) => {
                        dispatch(setIsSubmitting(false));
                        dispatch(userNotify(err.message, 'error'));
                    });
            }
        })
        .catch((err) => {
            dispatch(setIsSubmitting(false));
            dispatch(userNotify(err.message, 'error'));
        });
};

export const wrongOtpEntered = (val) => {
    return {
        type: 'WRONG_OTP_STATE',
        payload: val,
    };
};

export const verifyOTPForFFTVM = (eventid, data, next) => (dispatch) => {
    dispatch(setIsSubmitting(true));
    eventCallApi(`v3/dashboard/user/event/${eventid}/verify-otp`, 'post', { code: data.code })
        .then((res) => {
            dispatch(setIsSubmitting(false));
            if (res && res.status === 'Success') {
                // send data to google analytics
                // processGtmDatalayer({
                //   gtmPageView1:processPageViewUrlForNewOldLeadForm(EVEN_TRIGGER_CODE,`${LEADFORM_GOAL_TRACKING_STAGE['otp-verified']}/${data.leadFormTriggerCode||'user'}`,data.leadFormTriggerCode || 'user'),
                // }, null);
                dispatch(savedEventInfo(res.data.event));
                dispatch(
                    authenticateOTP(
                        {
                            otp: data.code,
                            phone: data.phone,
                            donotShowPopupError: data.donotShowPopupError,
                            leadFormTriggerCode: data.leadFormTriggerCode || 'user',
                        },
                        (err, result) => {
                            if (err) {
                                // dispatch(wrongOtpEntered(true))
                                return next('cannot verify otp');
                            } else {
                                return next(null, result);
                            }
                        }
                    )
                );
            }
        })
        .catch((err) => {
            if (!data.donotShowPopupError) {
                dispatch(userNotify(err.message, 'error'));
            }
            dispatch(setIsOtpInvalid(err.message));
            dispatch(setIsSubmitting(false));
            return next(err);
        });
};
export function setVendorLeadFormVisibleState(visibility, vendorSelectedId) {
    return {
        type: SET_VENDOR_LEAD_FORM_VISIBLE_STATE,
        getVendorLeadFormVisibleState: visibility,
        vendorSelectedId: vendorSelectedId,
    };
}
